import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {isSignedIn} from '/redux/selector/currentUser.selector';

import LoginProvider from './LoginProvider';

export default connect(createStructuredSelector({isSignedIn}))(LoginProvider);
